<script lang="ts" setup>
import { computed } from 'vue'
import IconCompleted from '@/components/icons/IconCompleted.vue'
import IconLock from '@/components/icons/IconLock.vue'

type ButtonTheme =
  | 'grey'
  | 'transparent'
  | 'expired'
  | 'success'
  | 'completed'
  | 'flat'
  | 'default'
  | 'green'
  | 'whiteGreen'
  | 'whitePurple'
  | 'flatGreen'
  | 'black'

const props = defineProps<{
  disabled?: boolean
  // button type
  grey?: boolean
  transparent?: boolean
  success?: boolean
  flat?: boolean
  completed?: boolean
  expired?: boolean
  green?: boolean
  whiteGreen?: boolean
  flatGreen?: boolean
  whitePurple?: boolean
  black?: boolean
}>()

const buttonType = computed<ButtonTheme>(() => {
  if (props.green) {
    return 'green'
  } else if (props.grey) {
    return 'grey'
  } else if (props.transparent) {
    return 'transparent'
  } else if (props.success) {
    return 'success'
  } else if (props.flat) {
    return 'flat'
  } else if (props.completed) {
    return 'completed'
  } else if (props.expired) {
    return 'expired'
  } else if (props.whiteGreen) {
    return 'whiteGreen'
  } else if (props.whitePurple) {
    return 'whitePurple'
  } else if (props.flatGreen) {
    return 'flatGreen'
  } else if (props.black) {
    return 'black'
  } else if (props.disabled) {
    return 'expired'
  } else {
    return 'default'
  }
})

const buttonClasses = computed(() => {
  switch (buttonType.value) {
    case 'flat':
      if (props.disabled) {
        return 'text-[#00000080] border-[#00000012]'
      }

      return 'text-[#5900CB] border-[#5900CB]'
    case 'completed':
    case 'success':
      return 'text-[#12A958] border-none bg-[#78F5B24D]'
    case 'expired':
    case 'grey':
      return 'text-[#00000080] border-none bg-[#00000012]'
    case 'green':
      return 'text-[#12A958] border-[#07955F] bg-[#07955F] text-white'
    case 'transparent':
      return 'text-[#00000080] border-[#00000012] bg-opacity-100'
    case 'whiteGreen':
      return 'text-[#07955F] border-[#FFFFFF] bg-[#FFFFFF]'
    case 'whitePurple':
      return 'text-[#5900CB] border-[#FFFFFF] bg-[#FFFFFF]'
    case 'flatGreen':
      return 'text-[#07955F] border-[#07955F] bg-[#FFFFFF]'
    case 'black':
      return 'text-[#FFFFFF] border-[#FFFFFF] bg-[#000000]'
    case 'default':
      return 'text-[#5900CB] border-[#5900CB] bg-[#5900CB] text-white'
    default:
      throw Error(`Unsupported button type ${buttonType.value}`)
  }
})
</script>
<template>
  <button
    class="border-2 rounded-[108px] px-[4px] py-[10px]"
    :class="buttonClasses"
    :disabled="props.disabled"
  >
    <template v-if="props.completed || props.expired">
      <div class="flex gap-[10px] justify-center items-center">
        <IconLock v-if="props.expired" />
        <span><slot></slot></span>
        <IconCompleted v-if="props.completed" />
      </div>
    </template>
    <slot v-else></slot>
  </button>
</template>
